import {
  getCarHouseLogos,
  assignLogoToCarHouse,
  deleteCarHouseLogo,
} from '../../lib/carHouseLogos';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCarHouseLogos = createAsyncThunk(
  'carHouseLogos/fetchCarHouseLogos',
  async ({ carHouseId, options = {} }) => {
    const data = await getCarHouseLogos(carHouseId, options);
    return data;
  }
);

export const addLogoToCarHouse = createAsyncThunk(
  'carHouseLogos/addLogo',
  async ({ carHouseId, logoId }, { rejectWithValue }) => {
    try {
      const data = await assignLogoToCarHouse(carHouseId, logoId);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeCarHouseLogo = createAsyncThunk(
  'carHouseLogos/const removeCarHouseLogo',
  async ({ carHouseId, logoId }) => {
    await deleteCarHouseLogo(carHouseId, logoId);
    return logoId;
  }
);
